// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".basic-background-hero-section[data-v-7ca93bb0]{color:#fff;text-align:center;padding:50px 0;position:relative}@media(min-width:768px){.basic-background-hero-section[data-v-7ca93bb0]{padding:85px 0}}.basic-background-hero-section[data-v-7ca93bb0]:before{content:\"\";display:block;position:absolute;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,.2)}.title[data-v-7ca93bb0]{margin:0;position:relative;z-index:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
